import { render, staticRenderFns } from "./drugs.vue?vue&type=template&id=4ff2a291&"
import script from "./drugs.vue?vue&type=script&lang=js&"
export * from "./drugs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports